import Vue from 'vue'

// bus.js
export default new Vue()
